import * as Sentry from '@sentry/react';
import { Navigate } from 'react-router';
import { SEARCH_SPACE_ROUTE } from '@jooxter/core';
import { usePermissions } from '@jooxter/permissions';
import { HomeManagement, HomeV2 } from './lazyPages';

/**
 * The landing page of every user (ND-6445): the management home for ADMIN and MANAGER users (ND-6514),
 * HomeV2 for the others. It gets its own error boundary: the global one would lock everybody out of
 * the app if the page crashed on some data, since every way back leads to `/home`. Instead, the user
 * lands on Spaces and Sentry gets the crash. Each visit to `/home` (navbar "Home", logo…) tries the
 * page again, and falls back to Spaces again if it still crashes.
 */
export const HomeRoute = () => {
  const {
    permissions: { managementHome },
  } = usePermissions();

  return (
    <Sentry.ErrorBoundary
      fallback={<Navigate to={SEARCH_SPACE_ROUTE} replace />}
      beforeCapture={(scope) => scope.setTag('boundary', managementHome ? 'home-management' : 'home-v2')}
    >
      {managementHome ? <HomeManagement /> : <HomeV2 />}
    </Sentry.ErrorBoundary>
  );
};
